import { CROPS_LOADED, LOAD_CROPS, RESET_CROPS, SYNC_FAILED } from './actionTypes';
import type { IAgronomyAgreementCropsState } from './types';

export const initialState: IAgronomyAgreementCropsState = {
  error: null,
  crops: [],
  loading: false,
  loaded: false,
};

export const reducer = (state = initialState, action: { type: any; payload?: any }) => {
  switch (action.type) {
    case LOAD_CROPS:
      return { ...state, error: null, loading: true };
    case CROPS_LOADED:
      return {
        ...state,
        error: null,
        crops: action.payload.data,
        loading: false,
        loaded: true,
      };
    case RESET_CROPS:
      return { ...initialState };
    case SYNC_FAILED:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
